/** @type {Record<string, PubSubCallback[]>} */
let subscribers = {};

/**
 * Registers a callback for an event. The returned function removes it again.
 * @param {string} eventName
 * @param {PubSubCallback} callback
 * @returns {() => void} unsubscribe
 */
function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

/**
 * Invokes every callback registered for an event, in subscription order.
 * @param {string} eventName
 * @param {unknown} [data]
 */
function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}